import React, { useState } from 'react';
import { View, Pressable } from 'react-native';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

import { Button } from 'app/src/elements/buttons';
import useToggle from 'app/src/hooks/useToggle';
import { Text } from 'app/src/styles';

import { ActionLabel } from './ActionLink';

const Container = styled(View)`
  gap: 10px;
  border-width: 1px;
  border-color: black;
  border-radius: 3px;
  padding: 10px;
`;

const ChooseOtpType = ({ email, otpType, options, loadUserStatus }) => {
  const [showOptions, toggleShowOptions] = useToggle();
  const [selectedType, setSelectedType] = useState();
  const { t } = useTranslation();

  const handleSubmit = () => {
    loadUserStatus({
      variables: { email: email, otpType: selectedType },
      onCompleted: () => toggleShowOptions(),
    });
  };

  return (
    <View style={{ marginTop: 6 }}>
      <Pressable onPress={toggleShowOptions}>
        <ActionLabel>{t('auth.otp.receiveAnotherWay')}</ActionLabel>
      </Pressable>

      {showOptions && (
        <Container>
          {options.map(option => (
            <View style={{ flexDirection: 'row', gap: 10 }}>
              <Pressable onPress={() => setSelectedType(option.type)}>
                {option.type === selectedType ? (
                  <FontAwesomeIcon
                    icon={faCircleCheck}
                    color="green"
                    size={24}
                    style={{ outlineStyle: 'none' }}
                  />
                ) : (
                  <FontAwesomeIcon icon={faCircle} size={24} />
                )}
              </Pressable>

              <Text key={`${option.type}-${option.maskedLabel}`}>
                {t(`auth.otp.${option.type}`)}{' '}
                {option.maskedLabel}
              </Text>
            </View>
          ))}

          <Button
            label={
              'app' === selectedType ? 'Use Authenticator App' : 'Send Code'
            }
            onPress={handleSubmit}
            disabled={!selectedType}
            wide
          />
        </Container>
      )}
    </View>
  );
};

export default ChooseOtpType;
